module.exports = __webpack_public_path__ + "National2Web-Bold.eot?aaa384db18d55713c3b6f2453abc9683";